
export const ITEM_LIST = { uri : '/addDev/item/list', id : 'itemList', initData : [] }
